import { supabase } from '@/integrations/supabase/client';

export interface PremiumProgress {
  assessment_id: string;
  responses: Record<string, any>;
  current_step: number;
  personal_info: any;
  updated_at: string;
}

export async function savePremiumProgress(
  assessmentId: string,
  responses: Record<string, any>,
  currentStep?: number,
  personalInfo?: any
) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { error } = await (supabase as any)
    .from('premium_assessment_progress')
    .upsert({
      user_id: user.id,
      assessment_id: assessmentId,
      responses,
      current_step: currentStep ?? 0,
      personal_info: personalInfo ?? null,
      updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id,assessment_id' });

  if (error) console.error('Error saving premium progress:', error);
}

export async function loadPremiumProgress(assessmentId: string): Promise<PremiumProgress | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await (supabase as any)
    .from('premium_assessment_progress')
    .select('*')
    .eq('user_id', user.id)
    .eq('assessment_id', assessmentId)
    .maybeSingle();

  if (error) {
    console.error('Error loading premium progress:', error);
    return null;
  }
  return data;
}

export async function deletePremiumProgress(assessmentId: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  await (supabase as any)
    .from('premium_assessment_progress')
    .delete()
    .eq('user_id', user.id)
    .eq('assessment_id', assessmentId);
}

export async function getAllPremiumProgress(): Promise<PremiumProgress[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];

  const { data, error } = await (supabase as any)
    .from('premium_assessment_progress')
    .select('*')
    .eq('user_id', user.id);

  if (error) {
    console.error('Error loading all premium progress:', error);
    return [];
  }
  return data || [];
}
